import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";

// Nothing here yet: one line that says so, one that says how to change it, and
// at most one action.

export interface EmptyStateProps {
  title: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  centered?: boolean;
}
export default function EmptyState({
  title,
  children,
  icon,
  action,
  centered = false
}: EmptyStateProps) {
  return <div {...{
    0: {
      className: "x78zum5 xdt5ytf x1cy8zhl xsuxsxl xvr2c1s"
    },
    1: {
      className: "x78zum5 xdt5ytf xsuxsxl xvr2c1s x6s0dn4 x2b8uid xvueqy4 x1lr1uin"
    }
  }[!!centered << 0]}>
      {icon && <span aria-hidden className="xovanlf x9cxqf0">
          {icon}
        </span>}
      <p className="x1ghz6dp xdj3nnt xk50ysn xgwkh9f">{title}</p>
      {children && <div className="x1ghz6dp xtu3avg x1i6qc9y x1lwm3bp">{children}</div>}
      {action && <div className="x7be28s">{action}</div>}
    </div>;
}